/* unplugin-vue-components disabled */import script from "./RightsDisplayComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./RightsDisplayComponents.vue?vue&type=script&setup=true&lang=js"

import "./RightsDisplayComponents.vue?vue&type=style&index=0&id=965b4d00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-965b4d00"]])

export default __exports__